/* sk-menu-morph v3 — seamless mega-menu switching (2026-07-14, theme 187189231896).
   When the visitor moves from one open mega menu straight to another, the theme
   normally plays a full close animation then a full open animation (the panel
   vanishes and re-appears). This patch detects that direct switch and instead:
   keeps ONE panel visually anchored, morphs its height from the outgoing panel's
   height to the incoming one's, and crossfades the content. First-opens and
   final closes keep the theme's original animation. Desktop only (>=1025px).

   v2 hardening (post stress-test):
   - clears the inline opacity that Motion's close-fade persists on panels
     (was leaving switched-to menus invisible after rapid back-and-forth)
   - per-menu generation counter so stale deferred closes can never act on a
     newer open/close cycle
   - syncBody() keeps body.dropdown-open truthful instead of trusting call order
   Rollback: remove this file + its <script> include in sections/header.liquid. */
(function () {
  var EASE = 'cubic-bezier(.22,.61,.36,1)';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getNav() {
    return document.querySelector('.header__menu');
  }

  function bodyEl() {
    return (window.NextSkyTheme && NextSkyTheme.getBody) ? NextSkyTheme.getBody() : document.body;
  }

  function syncBody() {
    var nav = getNav();
    var anyOpen = !!(nav && nav.querySelector('details.details-header-menu[open]'));
    bodyEl().classList.toggle('dropdown-open', anyOpen);
  }

  function openSiblings(el) {
    var nav = getNav();
    if (!nav) return [];
    var out = [];
    var all = nav.querySelectorAll('details.details-header-menu[open]');
    for (var i = 0; i < all.length; i++) if (all[i] !== el) out.push(all[i]);
    return out;
  }

  function clearResiduals(panel) {
    panel.style.opacity = '';
    panel.style.height = '';
    panel.style.overflow = '';
  }

  function silentClose(d) {
    try {
      d.__skSilent = false;
      d.summaryElement.removeAttribute('open');
      d.contentElement.removeAttribute('open');
      d.classList.remove('detail-open');
      d.removeAttribute('open');
      d.contentElement.style.zIndex = '';
      clearResiduals(d.contentElement);
      document.removeEventListener('click', d.detectClickOutsideListener);
      document.removeEventListener('keydown', d.detectEscKeyboardListener);
      document.removeEventListener('focusout', d.detectFocusOutListener);
    } catch (e) { /* never break the menu */ }
  }

  function patch() {
    var nav = getNav();
    if (!nav) return false;
    var first = nav.querySelector('details.details-header-menu');
    if (!first) return false;
    var proto = Object.getPrototypeOf(first);
    if (!proto || typeof proto.transition !== 'function') return false;
    if (proto.__skMorphPatched) return true;
    proto.__skMorphPatched = true;

    var orig = proto.transition;

    proto.transition = async function (value) {
      if (window.innerWidth < 1025) return orig.call(this, value);
      var gen = (this.__skGen = (this.__skGen || 0) + 1);
      var self = this;
      var panel = this.contentElement;

      /* ---------- opening ---------- */
      if (value) {
        this.__skSilent = false; /* an opening menu can never owe a silent close */
        var prev = openSiblings(this)[0];

        if (prev && prev.contentElement) {
          /* ---- seamless switch: prev panel -> this panel ---- */
          var prevH = prev.contentElement.getBoundingClientRect().height;

          /* retire the outgoing menu: instantly if its close already fired,
             otherwise flag it so its own close call is silent */
          if (!prev._open) {
            silentClose(prev);
          } else {
            prev.__skSilent = true;
            /* watchdog: if its close never fires (lost event under rapid
               input), either let a genuinely open menu live or finish the
               lost close — never leave the flag dangling */
            setTimeout(function () {
              if (prev.__skSilent) {
                if (prev._open) {
                  prev.__skSilent = false;
                } else {
                  silentClose(prev);
                  syncBody();
                }
              }
            }, 600);
          }

          /* open instantly with the exact attributes the theme's open path sets */
          this.setAttribute('open', '');
          this.summaryElement.setAttribute('open', '');
          document.addEventListener('click', this.detectClickOutsideListener);
          document.addEventListener('keydown', this.detectEscKeyboardListener);
          document.addEventListener('focusout', this.detectFocusOutListener);
          this.classList.add('detail-open');
          panel.setAttribute('open', '');

          /* wipe anything a previous animation persisted (Motion leaves
             inline opacity:0 after its close fade — the invisible-menu bug) */
          clearResiduals(panel);

          /* paint above the outgoing panel while it is still in the DOM */
          panel.style.zIndex = '30';

          if (!reduced) {
            var targetH = panel.getBoundingClientRect().height;
            if (prevH > 0 && targetH > 0 && Math.abs(prevH - targetH) > 1) {
              panel.style.overflow = 'hidden';
              var anim = panel.animate(
                [{ height: prevH + 'px' }, { height: targetH + 'px' }],
                { duration: 320, easing: EASE }
              );
              anim.onfinish = anim.oncancel = function () {
                panel.style.overflow = '';
                panel.style.height = '';
              };
            }
            var inner = panel.querySelector('.menu-container') || panel.firstElementChild;
            if (inner && inner.animate) {
              inner.animate(
                [
                  { opacity: 0, transform: 'translateY(8px)' },
                  { opacity: 1, transform: 'translateY(0)' }
                ],
                { duration: 280, delay: 40, easing: EASE, fill: 'backwards' }
              );
            }
          }
          setTimeout(function () {
            if (self.__skGen === gen) panel.style.zIndex = '';
          }, 420);
          syncBody();
          return;
        }

        /* fresh open — clear residual layout styles, let the theme animate.
           (orig's fade animates opacity 0 -> 1, so stale opacity self-heals) */
        panel.style.zIndex = '';
        panel.style.height = '';
        panel.style.overflow = '';
        return orig.call(this, value);
      }

      /* ---------- closing ---------- */
      if (this.__skSilent) {
        silentClose(this);
        syncBody();
        return;
      }

      /* brief grace period: if another menu opens right after, this becomes a switch */
      await new Promise(function (r) { setTimeout(r, 90); });
      if (self.__skGen !== gen) return;      /* superseded by a newer open/close */
      if (self._open) return;                /* re-opened during the grace period */
      if (self.__skSilent) {
        silentClose(self);
        syncBody();
        return;
      }
      if (!self.hasAttribute('open')) {      /* already closed silently elsewhere */
        syncBody();
        return;
      }
      await orig.call(self, value);
      /* the theme removes its open attribute on a ~300ms timer after this
         promise resolves — sync the overlay class after that, not before */
      setTimeout(syncBody, 380);
    };
    return true;
  }

  function boot() {
    if (patch()) return;
    /* custom element may not be upgraded yet — retry briefly */
    var tries = 0;
    var t = setInterval(function () {
      if (patch() || ++tries > 40) clearInterval(t);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
